import { ReactNode } from "react";

interface MenuButtonProps {
  onClick?: () => void;
  className?: string;
  disabled?: boolean;
  isActive?: boolean;
  children?: ReactNode;
  title?: string;
}

export function MenuButton({
  onClick,
  className,
  disabled,
  isActive,
  children,
  title,
}: MenuButtonProps) {
  const buttonClasses = () => {
    const baseClasses = (classes?: string) => {
      return `w-8 h-8 mx-0.5 my-2 p-0 bg-white text-primary-100 font-bold flex rounded justify-center items-center cursor-pointer text-normal shadow-button active:scale-90 hover:bg-primary-600 ${className}`;
    };

    if (isActive) return baseClasses("bg-primary-500 text-primary-100");
    if (disabled)
      return `bg-tertiary-300 text-tertiary-500 font-normal ${className} cursor-not-allowed hover:bg-tertiary-600 hover:text-tertiary-500`;
    else return baseClasses("hover:bg-primary-600 hover:text-white");
  };

  return (
    <button
      title={title}
      disabled={disabled}
      onClick={onClick}
      type="button"
      className={buttonClasses()}
    >
      {children}
    </button>
  );
}
